import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { GlobalService } from 'src/app/service/global.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ApprovalFlowService } from '../approval-flow-models/approval-flow.service';
import { WorkflowNames } from '../approval-flow-models/workflow-names.model';
import { WorkflowTicket } from '../approval-flow-models/workflow-ticket.model';

@Component({
  selector: 'app-ticket-pending',
  templateUrl: './ticket-pending.component.html',
  styleUrls: ['./ticket-pending.component.css']
})
export class TicketPendingComponent implements OnInit {
  pendingApprovals: WorkflowTicket[];
  allPendingApprovals: WorkflowTicket[];
  ordersTableColumns: TableColumn[];
  columnsData: any;
  workFlows: WorkflowNames[];
  filteredPendingApprovals: WorkflowTicket[];
  allFilteredPendingApprovals: WorkflowTicket[];
  actions: any;
  isAccessDisabled: boolean = false;

  constructor(private authGurdService: AuthGaurdService, private approvalFlowService: ApprovalFlowService,
    private httpService: HttpClient, private router: Router, private globalService: GlobalService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.findAllPendingApprovals();
    //this.findPendingApprovals();
    this.initializeColumns();
    this.isAccessDisabled = this.globalService._permissionCheck('adjustments-approval');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
  }

  findAllPendingApprovals() {
    console.log("Inside findAllPendingApprovals");
    console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));

    this.approvalFlowService.findAllPendingApprovalsDashboard(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'), localStorage.getItem('CURRENT_USERROLE_SESSION'))
      .subscribe((data: WorkflowTicket[]) => {
        this.allFilteredPendingApprovals = data;
        console.log(this.allFilteredPendingApprovals);
        // this.allPendingApprovals = data;
        // console.log(this.allPendingApprovals);
        // if (this.allPendingApprovals.length > 0)
        //   this.loadAllWorkflowNames()
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }


  findPendingApprovals() {
    this.approvalFlowService.findPendingApprovals(this.authGurdService.loginEmployeeId())
      .subscribe((data: WorkflowTicket[]) => {
        this.pendingApprovals = data;
        this.loadWorkflowNames()
      }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  loadWorkflowNames() {
    this.approvalFlowService.loadWorkflowNames()
      .subscribe((data: WorkflowNames[]) => {
        this.workFlows = data;
        for (let workflow of this.workFlows) {
          this.filteredPendingApprovals = this.pendingApprovals.filter(pendingApproval =>
            pendingApproval.flow_id === workflow.id ? pendingApproval.flowName = workflow.workflow_name : pendingApproval);
        }
        console.log(this.authGurdService.userRole);
        if (this.authGurdService.userRole === "ADMIN" && this.pendingApprovals.length === 0)
          this.findAllPendingApprovals();
        console.log(this.filteredPendingApprovals);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }


  loadAllWorkflowNames() {
    this.approvalFlowService.loadWorkflowNames()
      .subscribe((data: WorkflowNames[]) => {
        this.workFlows = data;
        for (let workflow of this.workFlows) {
          this.allFilteredPendingApprovals = this.allPendingApprovals.filter(pendingApproval =>
            pendingApproval.flow_id === workflow.id ? pendingApproval.flowName = workflow.workflow_name : pendingApproval);
        }

        console.log(this.allFilteredPendingApprovals);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  exportExcel() {
  }

  rowAction(row: any) {
    console.log(row);
    this.approvalFlowService.pendingWorkflowTicket = row.row;
    if (!this.isAccessDisabled)
      this.redirect('ticket-process');
  }


  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.PendingApprovals;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Process',
        dataKey: 'far fa-caret-square-right f-25',
        position: 'center',
        isSortable: false,
        class: 'badge bg-success'
      }]
  }

}

